import React, { useEffect, useRef } from "react";
import { Form } from "react-bootstrap";

/**
 * Checkbox component that supports an indeterminate state via `checked={undefined}`.
 * All props except `type` are forwarded to the underlying Form.Check.
 */
export interface IndeterminateCheckboxProps extends Omit<React.ComponentProps<typeof Form.Check>, "type" | "checked"> {
  checked: boolean | undefined;
}

export const IndeterminateCheckbox = React.forwardRef<HTMLInputElement, IndeterminateCheckboxProps>(
  ({ checked, ...props }, ref) => {
    const innerRef = useRef<HTMLInputElement>(null);
    // Prefer the forwarded ref if provided, otherwise use our own
    const resolvedRef = (ref ?? innerRef) as React.RefObject<HTMLInputElement>;

    useEffect(() => {
      if (resolvedRef.current) {
        resolvedRef.current.indeterminate = checked === undefined;
      }
    }, [checked, resolvedRef]);

    return <Form.Check {...props} ref={resolvedRef} checked={!!checked} type="checkbox" />;
  },
);
IndeterminateCheckbox.displayName = "IndeterminateCheckbox";
